<template>
  <NavBar class="AdminNavBar">
    <router-link
      v-if="isStored"
      class="d-inline-flex align-center mr-4"
      :to="{ name: 'Upload', params: { municipality: municipalitySlug } }"
    >
      <i class="far fa-fw fa-file-upload icon" />
    </router-link>
    <span
      v-else
      class="d-inline-flex align-center mr-4"
    >
      <i class="far fa-fw fa-file-upload icon" />
    </span>

    <router-link
      v-if="isStored && isEnabled"
      class="d-inline-flex align-center mr-4"
      :to="{ name: 'Viewer', params: { municipality: municipalitySlug } }"
    >
      <i class="far fa-fw fa-map icon" />
    </router-link>
    <span
      v-else
      class="d-inline-flex align-center mr-4"
    >
      <i class="far fa-fw fa-map icon" />
    </span>
  </NavBar>
</template>

<script>
import NavBar from '@/components/common/NavBar'

import { mapGetters } from 'vuex'

import { codeToSlug } from '@/services/municipalities'

export default {
  name: 'AdminNavBar',
  components: {
    NavBar,
  },
  computed: {
    ...mapGetters('access',
      ['getActiveMunicipality'],
    ),
    ...mapGetters('config', [
      'isStoredByCode',
      'isPlanmodeEnabled',
      'isEnabled',
    ]),
    municipalitySlug() {
      return codeToSlug({ code: this.getActiveMunicipality })
    },
    isStored() {
      return this.isStoredByCode({ code: this.getActiveMunicipality })
    },
  },
}
</script>
<style>
.AdminNavBar span:not(.NavBar__Profile):not(.NavBar__Logout) .icon {
  cursor: not-allowed;
}
</style>
